export default __webpack_public_path__ + "static/media/local_atm_black_24dp.d77a251a.svg";